import { render, staticRenderFns } from "./MessageReactions.vue?vue&type=template&id=4a406c99&"
import script from "./MessageReactions.vue?vue&type=script&lang=js&"
export * from "./MessageReactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports